import { gql, useMutation } from '@apollo/client'
import ActionModal from 'components/Dashboard/ActionModal'
import TextInput from 'components/TextInput'
import mutationResponseToToast, { mutationResponseFragment } from './mutationResponseToToast'
import {
  CancelOrderShipmentMutation,
  CancelOrderShipmentMutationVariables,
} from './__generated__/CancelOrderShipmentMutation'

const cancelOrderShipmentMutation = gql`
  mutation CancelOrderShipmentMutation($input: CancelOrderShipmentInput!) {
    cancelOrderShipment(input: $input) {
      success
      message
      shipment {
        id
        status
      }

      ...MutationResponseFragment
    }
  }

  ${mutationResponseFragment}
`

interface FormValues {
  reason: string
  zdRef: string
}

interface CancelOrderShipmentModalProps {
  shipmentId: string
  onRequestClose: () => void
}

const CancelOrderShipmentModal = ({ shipmentId, onRequestClose }: CancelOrderShipmentModalProps) => {
  const [cancelOrderShipment] = useMutation<CancelOrderShipmentMutation, CancelOrderShipmentMutationVariables>(
    cancelOrderShipmentMutation
  )

  return (
    <ActionModal<FormValues>
      header={<>Cancel shipment {shipmentId}</>}
      formikInitialValues={{ reason: '', zdRef: '' }}
      onRequestClose={onRequestClose}
      submitText="Cancel Order Shipment"
      onSubmit={async (values, { addToast }) => {
        const resp = await cancelOrderShipment({
          variables: {
            input: {
              shipmentId,
              reason: values.reason,
              zdRef: values.zdRef,
            },
          },
        })

        if (!resp.data.cancelOrderShipment.success) {
          throw new Error(resp.data.cancelOrderShipment.message || 'Something went wrong')
        }

        addToast(mutationResponseToToast(resp.data.cancelOrderShipment))
      }}
    >
      <TextInput name="reason" label="Reason for change (optional)" />
      <TextInput name="zdRef" label="Zendesk ticket no (if applicable)" />
    </ActionModal>
  )
}

export default CancelOrderShipmentModal
